import { styled } from '@mui/material';

export const StyledList = styled('ul')(() => ({
  marginTop: 0,
}));
